{
  "name": "next-cloudinary",
  "version": "5.20.0",
  "license": "MIT",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "source": "src/index.ts",
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "prepublishOnly": "cp ../README.md . && cp ../LICENSE . && yarn build",
    "postpublish": "rm ./README.md && rm ./LICENSE",
    "test": "jest",
    "test:app": "NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME=\"test\" yarn build && cd tests/nextjs-app && yarn build"
  },
  "dependencies": {
    "@cloudinary-util/url-loader": "^4.1.1",
    "@cloudinary-util/util": "^2.3.0"
  },
  "devDependencies": {
    "@babel/core": "^7.23.2",
    "@babel/preset-env": "^7.23.2",
    "@types/jest": "^29.5.6",
    "@types/react": "^18.2.33",
    "@types/react-dom": "^18.2.14",
    "babel-jest": "^29.7.0",
    "dotenv": "^16.3.1",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "mkdirp": "^3.0.1",
    "ts-jest": "^29.1.1",
    "tsup": "^7.2.0",
    "typescript": "^5.2.2"
  },
  "peerDependencies": {
    "next": "^12 || ^13 || ^14",
    "react": "^17 || ^18"
  }
}
